import { __read, __spreadArray } from "tslib";
import { combineLatestInit } from '../observable/combineLatest';
import { Observable } from '../Observable';
export function combineLatestWith() {
    var otherSources = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        otherSources[_i] = arguments[_i];
    }
    return function (source) { return new Observable(function (subscriber) { return combineLatestInit(__spreadArray([source], __read(otherSources), false))(subscriber); }); };
}
//# sourceMappingURL=combineLatestWith.js.map